import { useState, useEffect } from "react";
import { subscribeToLeadHistory } from "../services/leads.service";
import { mapHistoryToMessages } from "../utils/firebaseLeadsMapper";

export function useLeadHistory(waId) {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!waId) {
      setMessages([]);
      return;
    }

    setLoading(true);

    const unsubscribe = subscribeToLeadHistory(waId, (raw) => {
      setMessages(mapHistoryToMessages(raw));
      setLoading(false);
    });

    return () => unsubscribe();
  }, [waId]);

  return { messages, loading };
}
